<template>
  <div class="form-control-static">
    <p v-if="value && value.length === 0" v-html="i18n.fr('html.empty')"></p>
    <div v-for="(_spec, i) in _specs" style="margin-bottom: .5em">
      <button v-if="!_readonly && spec.delete"
              :disabled="typeof spec.min === 'number' && value.length <= spec.min"
              type="button" class="btn btn-icon btn-danger" style="float: left" :title="i18n.fr('action.delete')"
              @click="del(_spec.idx)">
        <i class="ti-minus"></i>
      </button>
      <div :style="{'margin-left': spec.delete ? '44px' : 0}">
        <div v-if="!spec.present">{{i18n.fr('fields.array_item_$i', {i: i + 1})}}</div>
        <component :is="spec.itemType.component"
                   ref="fields"
                   :name="_spec.spec.prop"
                   :spec="_spec.spec"
                   :model="value"
                   :$parentForm="this"
                   :rootModel="rootModel"
                   :$rootForm="$rootForm"
                   :readonly="_readonly"
                   :key="_spec.spec.prop"
                   style="padding-top: 0"></component>
        <small class="text-danger" v-show="validator.errors.has(String(_spec.idx))">
          {{validator.errors.first(String(_spec.idx))}}
        </small>
      </div>
    </div>
    <button v-if="!_readonly && spec.add && !(typeof spec.max === 'number' && value.length >= spec.max)"
            type="button" class="btn btn-icon btn-info"
            @click="add">
      <i class="ti-plus"></i>
      {{i18n.fr('action.add')}}
    </button>
  </div>
</template>

<script>
  import {assign, every, get, map} from 'lodash';
  import mixin from './mixin';
  import {Validator} from 'vee-validate';
  import i18n from 'src/i18n';
  import {sanitizeModel} from 'src/schemas/utils';

  export default {
    name: 'f-array',
    mixins: [mixin],
    data() {
      return {
        validator: Validator.create(),
      };
    },
    computed: {
      _specs() {
        return map(this.value, (value, idx) => ({idx, spec: {...this.spec.itemType, prop: String(idx)}}));
      },
    },
    methods: {
      add() {
        if (!this.value) this.value = [];
        if (!(typeof this.spec.max === 'number' && this.value.length >= this.spec.max)) {
          let temp = {obj: undefined};
          sanitizeModel.call(this, temp, [{...this.spec.itemType, prop: 'obj'}])
              .then(x => this.value.push(x.obj));
        }
      },
      del(idx) {
        if (!this.value) this.value = [];
        if (!(typeof this.spec.min === 'number' && this.value.length <= this.spec.min)) {
          this.value.splice(idx, 1);
        }
      },
      validate() {
        let p = [];
        this.validator = Validator.create();
        if (!this._readonly && this.value && this.spec.itemType.validation) {
          for (let i = 0; i < this.value.length; ++i) {
            this.validator.attach(String(i), this.spec.itemType.validation);
          }
        }
        p.push(this.validator.validateAll(this.value));
        if (this.$refs.fields) {
          for (let f of this.$refs.fields) {
            if (typeof f.validate === 'function') {
              p.push(f.validate());
            }
          }
        }
        return Promise.all(p).then(valid => {
          return every(valid);
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// f-array.vue?ed31d2e4